import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { AuthorizationReducer } from '../reducers/authorization/reducers';

export const makeRootReducer = (history) => {
  return combineReducers({
    router: connectRouter(history),
    authentication: AuthorizationReducer,
  });
};